const YBERA_CDN = "lojaybera.fbitsstatic.net";

function parseCdnUrl(url: string): URL | null {
  try {
    const parsed = new URL(url, "https://progressivafashionloja.com");
    if (parsed.hostname.replace(/^www\./, "") !== YBERA_CDN) return null;
    return parsed;
  } catch {
    return null;
  }
}

/** Resize + WebP via the Ybera/Wake CDN. Local and WordPress URLs are left unchanged. */
export function optimizeImage(url: string, width: number): string {
  const parsed = parseCdnUrl(url);
  if (!parsed) return url;
  parsed.searchParams.set("w", String(Math.round(width)));
  parsed.searchParams.set("format", "webp");
  return parsed.toString();
}

export function imageSrcSet(url: string, widths: number[]): string | undefined {
  if (!parseCdnUrl(url)) return undefined;
  return widths.map((width) => `${optimizeImage(url, width)} ${width}w`).join(", ");
}

export function isYberaCdn(url: string): boolean {
  return Boolean(parseCdnUrl(url));
}

/** Apply CDN resize/WebP to every Ybera image in a media map; local paths stay as-is. */
export function optimizeMedia<T extends Record<string, string>>(media: T, width = 800): T {
  const next = { ...media };
  for (const key of Object.keys(next) as Array<keyof T>) {
    next[key] = optimizeImage(String(next[key]), width) as T[keyof T];
  }
  return next;
}
